


























import { mixins } from 'vue-class-component'
import { Component, Prop, Watch } from 'vue-property-decorator'
import AppTextSearch from '@/components/AppTextSearch.vue'
import AppTextField from '@/components/AppTextField.vue'
import AppSelector from '@/components/AppSelector.vue'
import AppFormCheckbox from '@/components/AppFormCheckbox.vue'
import SearchAccount from '@/mixins/search-queries/search-account'
import { Account } from '@/modules/Account/interfaces/account'
import { IContactAccountInput } from '@/modules/Contact/interfaces/contact-form'
import { salutationValues } from '@/modules/Contact/helpers/contact'

@Component({
  components: {
    AppTextSearch,
    AppTextField,
    AppSelector,
    AppFormCheckbox
  }
})
export default class ContactFormAccount extends mixins(SearchAccount) {
  @Prop({ type: Object as () => IContactAccountInput }) value!: IContactAccountInput
  @Prop({ type: Object as () => Account }) readonly account!: Account

  salutationOptions = salutationValues

  get disableAccount () {
    return !!this.account
  }

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
